/* eslint-disable react-hooks/rules-of-hooks */
import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'
import { Row, Col, Form, Card, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faTimes } from '@fortawesome/free-solid-svg-icons'
// import AdExchangeChart from './AdExchangeChart'

function Names({ setting }) {
  const {
    allKeys,
    hideKeys,
    sethideKeys,
    allNames,
    fieldLabelMap,
    names = {},
    handleEditNames,
  } = setting

  return (
    <Card className="px-0">
      <Card.Header>名稱與欄位設定</Card.Header>
      <Card.Body
        className="d-flex flex-column"
        style={{
          height: '75vh',
        }}
      >
        <Row className="h-100">
          <Col className="h-100">
            <Row>
              <Form.Label>欄位設定</Form.Label>
            </Row>
            <div
              className="overflow-scroll flex-fill border p-2 rounded"
              style={{ maxHeight: '92%' }}
            >
              {allKeys
                // .filter((key) => key !== 'Dimension.DATE')
                .map((key) => (
                  <Row id={key}>
                    <Col xs={2}>
                      <Form.Check
                        checked={!hideKeys[key]}
                        onChange={() =>
                          sethideKeys({
                            ...hideKeys,
                            [key]: !hideKeys[key],
                          })
                        }
                      />
                    </Col>
                    <Col>{fieldLabelMap[key] || key}</Col>
                  </Row>
                ))}
            </div>
          </Col>
          <Col className="h-100">
            <Row>
              <Form.Label>名稱設定</Form.Label>
            </Row>
            <div
              className="overflow-scroll flex-fill border p-2 rounded"
              style={{ maxHeight: '92%' }}
            >
              {allNames.map((n) => (
                <Row id={n}>
                  <Col>{n}</Col>
                  <Col>
                    <Form.Control
                      name={n}
                      onChange={handleEditNames}
                      value={names[n] || ''}
                    />
                  </Col>
                </Row>
              ))}
            </div>
          </Col>
        </Row>
      </Card.Body>
      {/* <Modal.Footer className="sendForm justify-content-center py-3">
        <Button variant="secondary" onClick={() => handleClose()}>
          預覽
        </Button>
        <Button variant="dai" onClick={() => handleClose(true)}>
          預覽並儲存
        </Button>
      </Modal.Footer> */}
    </Card>
  )
}

function Mockup({ setting }) {
  const { sites, adUnits, handleEditMockup, handleDeleteMockup, id } = setting
  const {
    siteFilter,
    adUnitFilter,
    dateFrom,
    dateTo,
    value,
    target = 'REVENUE',
  } = setting
  const handleDataChange = (e) => {
    handleEditMockup(id, e.target.name, e.target.value)
  }

  return (
    <Form className="mb-3">
      <Row className="g-2 align-items-end">
        <Col md={2}>
          <Form.Group controlId="siteFilter">
            <Form.Label>Website</Form.Label>
            <Form.Select
              name="siteFilter"
              value={siteFilter}
              onChange={handleDataChange}
            >
              <option value="ALL">All</option>
              {sites.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group controlId="adUnitFilter">
            <Form.Label>Ad Unit</Form.Label>
            <Form.Select
              name="adUnitFilter"
              value={adUnitFilter}
              onChange={handleDataChange}
            >
              <option value="ALL">All</option>
              {adUnits.map((u) => (
                <option key={u} value={u}>
                  {u}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group controlId="dateFrom">
            <Form.Label>From</Form.Label>
            <Form.Control
              name="dateFrom"
              type="date"
              value={dateFrom}
              onChange={handleDataChange}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group controlId="dateTo">
            <Form.Label>To</Form.Label>
            <Form.Control
              name="dateTo"
              type="date"
              value={dateTo}
              onChange={handleDataChange}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group controlId="adUnitFilter">
            <Form.Label>目標欄位</Form.Label>
            <Form.Select
              name="target"
              value={target}
              onChange={handleDataChange}
            >
              {[
                'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE',
                'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS',
                'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS',
              ].map((u) => (
                <option key={u} value={u}>
                  {u.split('_').pop()}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={1}>
          <Form.Group controlId="value">
            <Form.Label>倍率</Form.Label>
            <Form.Control
              name="value"
              type="tel"
              value={value}
              onChange={handleDataChange}
            />
          </Form.Group>
        </Col>
        <Col md={1}>
          <FontAwesomeIcon
            className="btn"
            onClick={() => handleDeleteMockup(id)}
            icon={faTimes}
          />
        </Col>
      </Row>
    </Form>
  )
}

function Mockups({ setting }) {
  const {
    // show,
    // handleClose,
    sites,
    adUnits,
    mockups = [],
    handleEditMockup = () => {},
    handleAddMockup = () => {},
    handleDeleteMockup = () => {},
  } = setting

  return (
    <Card className="px-0">
      <Card.Header>
        <Row>
          <Col xs={2} />
          <Col>含潤設定</Col>
          <Col className="ms-auto" xs={2}>
            <Button onClick={handleAddMockup} className="text-nowrap">
              新增&ensp;
              <FontAwesomeIcon icon={faPlusCircle} />
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        {mockups.map((mockup) => (
          <Mockup
            setting={{
              ...mockup,
              sites,
              adUnits,
              handleEditMockup,
              // handleAddMockup,
              handleDeleteMockup,
            }}
          />
        ))}
      </Card.Body>
      {/* <Modal.Footer className="sendForm justify-content-center py-3">
        <Button variant="secondary" onClick={() => handleClose()}>
          預覽
        </Button>
        <Button variant="dai" onClick={() => handleClose(true)}>
          預覽並儲存
        </Button>
      </Modal.Footer> */}
    </Card>
  )
}

function ReportListSetting({ setting }) {
  const {
    setLinkId,
    setshowsetting,
    handleEditLink = () => {},
    data = [],
    fieldLabelMap = {},
    form = {},
  } = setting
  console.log(form.columns)

  if (!data || data.length === 0) return <div>無資料</div>

  const [siteFilter] = useState('ALL')
  const [adUnitFilter] = useState('ALL')
  const [dateFrom] = useState('')
  const [dateTo] = useState('')

  // 名稱與欄位設定
  const [hideKeys, sethideKeys] = useState(setting.hideKeys || {})
  const [names, setNames] = useState(setting.names || {})
  const [showNames, setshowNames] = useState(false)
  const handleEditNames = (e) => {
    setNames({
      ...names,
      [e.target.name]: e.target.value,
    })
  }
  const handleNamesClose = (value) => {
    if (value) {
      handleEditLink({
        names,
      })
    }
    setshowNames(false)
  }

  const [mockups, setmockups] = useState(setting.mockups || [])
  const [showMockups, setshowMockups] = useState(false)
  const handleMockupClose = (value) => {
    if (value) {
      handleEditLink({
        mockups,
      })
    }
    setshowMockups(false)
  }
  const handleAddMockup = () =>
    setmockups((prev) => [
      {
        id: uuid(),
        siteFilter: 'ALL',
        adUnitFilter: 'ALL',
        dateFrom: '',
        dateTo: '',
        value: 1,
      },
      ...prev,
    ])
  const handleEditMockup = (id, key, value) => {
    setmockups((prev) =>
      prev.map((p) =>
        p.id === id
          ? {
              ...p,
              [key]: value,
            }
          : p
      )
    )
  }
  const handleDeleteMockup = (id) => {
    setmockups((prev) => prev.filter((p) => p.id !== id))
  }

  const allKeys = Object.keys(data[0]).filter((key) => !key.includes('_ID'))
  // const dimensionKeys = allKeys
  //   .filter((k) => k.startsWith('Dimension.'))
  //   .filter((k) => !hideKeys[k])
  // const columnKeys = form.extraFields
  //   .filter((f) => f.active)
  //   .map((f) => f.label)
  //   .concat(
  //     allKeys.filter((k) => k.startsWith('Column.')).filter((k) => !hideKeys[k])
  //   )
  // const x1 = dimensionKeys.length * 2
  // const x2 = columnKeys.length * 2

  const sites = useMemo(() => {
    const vals = new Set(
      data.map(
        (r) => r['Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[13107349]_VALUE']
      )
    )
    return Array.from(vals).sort()
  }, [data])

  const adUnits = useMemo(() => {
    const vals = new Set(data.map((r) => r['Dimension.AD_UNIT_NAME']))
    return Array.from(vals).sort()
  }, [data])

  const checkFilter = (row, filter) => {
    const site = row['Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[13107349]_VALUE']
    const ad = row['Dimension.AD_UNIT_NAME']
    const date = row['Dimension.DATE']
    if (filter.siteFilter !== 'ALL' && site !== filter.siteFilter) return false
    if (filter.adUnitFilter !== 'ALL' && ad !== filter.adUnitFilter)
      return false
    if (filter.dateFrom && date < filter.dateFrom) return false
    if (filter.dateTo && date > filter.dateTo) return false
    return true
  }
  const filtered = useMemo(
    () =>
      data
        .filter((row) => {
          const site =
            row['Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[13107349]_VALUE']
          const ad = row['Dimension.AD_UNIT_NAME']
          const date = row['Dimension.DATE']
          if (siteFilter !== 'ALL' && site !== siteFilter) return false
          if (adUnitFilter !== 'ALL' && ad !== adUnitFilter) return false
          if (dateFrom && date < dateFrom) return false
          if (dateTo && date > dateTo) return false
          return true
        })
        .map((row) => {
          const mockValue = {
            'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS': 1,
            'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS': 1,
            'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE': 1,
          }
          mockups.forEach((mockup) => {
            if (checkFilter(row, mockup)) {
              mockValue[
                mockup.target || 'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE'
              ] =
                mockValue[
                  mockup.target || 'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE'
                ] * mockup.value
            }
          })
          const ans = Object.keys(row).reduce(
            (prev, key) => ({
              ...prev,
              [key]: mockValue[key] ? row[key] * mockValue[key] : row[key],
            }),
            {}
          )
          form.extraFields.forEach((field) => {
            if (field.active) {
              ans[field.label] = field.depend.reduce(
                (prev, cur) =>
                  prev + cur.multipler * ans[`Column.${cur.column}`],
                0
              )
            }
          })
          // ans.AQUARIUM_IMPRESSION =
          //   (ans['Column.AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS'] || 0) +
          //   (ans['Column.AD_SERVER_IMPRESSIONS'] || 0)
          // ans.AQUARIUM_REVENUE =
          //   (ans['Column.AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE'] || 0) +
          //   (ans['Column.AD_SERVER_IMPRESSIONS'] || 0)
          return ans
        }),
    [data, siteFilter, adUnitFilter, dateFrom, dateTo, showMockups]
  )

  return (
    <div className="flex-nowrap text-nowrap p-3">
      <Row>
        <Mockups
          setting={{
            show: showMockups,
            handleClose: handleMockupClose,
            sites,
            adUnits,
            mockups,
            handleAddMockup,
            handleEditMockup,
            handleDeleteMockup,
          }}
        />
      </Row>

      <Row className="mt-2">
        <Names
          setting={{
            show: showNames,
            handleClose: handleNamesClose,
            names,
            handleEditNames,
            allKeys,
            hideKeys,
            sethideKeys,
            fieldLabelMap,
            allNames: Array.from(
              new Set(
                Object.keys(fieldLabelMap)
                  .map((key) => fieldLabelMap[key])
                  .concat(filtered.map((row) => row['Dimension.AD_UNIT_NAME']))
                  .concat(
                    filtered.map((row) => row['Dimension.LINE_ITEM_NAME'])
                  )
                  .concat(
                    filtered.map(
                      (row) =>
                        row[
                          'Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[13107349]_VALUE'
                        ]
                    )
                  )
              )
            ),
          }}
        />
      </Row>

      <Row className="mt-2">
        <Col className="d-flex py-3" xs={7}>
          {/* {response && !reportStatus && (
                      <Alert variant="info" className="my-auto w-100">
                        🧾 報表建立中... ReportJob ID: {response.id}
                      </Alert>
                    )}
      
                    {reportStatus && reportStatus !== 'COMPLETED' && (
                      <Alert variant="warning" className="my-auto w-100">
                        ⏳ 報表狀態：{reportStatus}
                      </Alert>
                    )}
      
                    {error && (
                      <Alert variant="danger" className="my-auto w-100">
                        ❌ 錯誤：{error}
                      </Alert>
                    )} */}
        </Col>

        <Col xs={1} className="ms-auto text-nowrap d-flex">
          <Button
            className="me-3 my-auto"
            variant="secondary"
            onClick={() => setLinkId('')}
          >
            返回列表
          </Button>
        </Col>
        <Col xs={1} className="text-nowrap d-flex">
          <Button
            onClick={() => {
              setshowsetting(1)
            }}
            className="me-3 my-auto"
            variant="secondary"
          >
            重新設定
          </Button>
        </Col>
        <Col xs={2} className="ms-1 text-nowrap d-flex">
          <Button
            className="my-auto"
            onClick={() => {
              handleEditLink({
                names,
                mockups,
                hideKeys,
              })
            }}
          >
            儲存設定並預覽
          </Button>
        </Col>
      </Row>
    </div>
  )
}

Names.propTypes = {
  setting: PropTypes.shape().isRequired,
}

Mockup.propTypes = {
  setting: PropTypes.shape().isRequired,
}

Mockups.propTypes = {
  setting: PropTypes.shape().isRequired,
}

ReportListSetting.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default ReportListSetting
